export enum AnnouncmentType {
  Maintenance = 'Maintenance',
  Status = 'Status',
}
